"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToHTML = void 0;
const draft_js_export_html_1 = require("draft-js-export-html");
const convertToHTML = (editorState) => {
    return draft_js_export_html_1.stateToHTML(editorState.getCurrentContent());
};
exports.convertToHTML = convertToHTML;
//# sourceMappingURL=textEditorUtils.js.map